import './middleSection.css';

function MiddleSection({ children }) {

  return (
    <div className="content-master-container">
      {children}
    </div>
  )
}

export default MiddleSection;